module.exports = __webpack_public_path__ + "static/media/dacast-logo.ff9baa3f.png";